export default __webpack_public_path__ + "static/media/pre.8fda50b6.svg";